import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import { DOMSerializer } from '@tiptap/pm/model';

export function createNotesEditorExtensions({ placeholder }) {
  return [
    StarterKit.configure({
      heading: { levels: [2, 3] },
    }),
    Underline,
    Link.configure({
      openOnClick: false,
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    TextStyle,
    Color,
    Placeholder.configure({
      placeholder: placeholder || 'Start writing notes for this day…',
      emptyEditorClass: 'vrc-notes-editor-empty',
    }),
  ];
}

export function serializeNotesDoc(editor) {
  if (!editor?.state?.doc || typeof document === 'undefined') return '';
  const serializer = DOMSerializer.fromSchema(editor.schema);
  const container = document.createElement('div');
  editor.state.doc.forEach((child) => {
    try {
      container.appendChild(serializer.serializeNode(child));
    } catch {
      // skip unsupported nodes
    }
  });
  return container.innerHTML;
}
